import React, { useState, useRef, useEffect } from 'react';
import PageHeader from '../../components/page/PageHeader';
import { update_page_meta } from '../../actions/page/header';
import { connect } from 'react-redux';
import axios from 'axios';
import { JSON_CONTENT_FORM_CONFIG } from '../../actions/Config';
import { Link, useNavigate } from 'react-router-dom';
import { HomePageURL } from '../../assets/const';
import { selectProduct } from '../../actions/products/products';
import { useSearchParams } from "react-router-dom";

const MoveList = ({ update_page_meta, selectProduct }) => {
  update_page_meta({
      title: "Product Transfers",
      description: "All product transfers"
  });
  const [productTransfers, setProductTransfers] = useState([]);
  let [searchParams, setSearchParams] = useSearchParams();
  const [totalPages, setTotalPages] = useState(1);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [fetching, setFetching] = useState(false);
  const bottomElementRef = useRef();
  useEffect(() => {
      const fetchMore = async () => {
        if (page > totalPages || fetching) return;
        try {
          setFetching(true);
          let params = `page=${page}&page_size=${pageSize}`;
          const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/stock/fetch-transfers/?${params}`, JSON_CONTENT_FORM_CONFIG);
          if (response.status === 200) {
                setProductTransfers((prevItems) => {
                  if (page === 1) {
                      return response.data.results; // Set the initial orders
                  } else {
                      return [...prevItems, ...response.data.results]; // Append new orders
                  }
              });
              setTotalPages(response.data.num_pages);
              setPage(page + 1);
          }
        } catch (error) {
          console.error("Error fetching more products:", error);
        } finally {
          setFetching(false);
        }
      };
      const options = {
        root: null, // viewport
        rootMargin: "0px",
        threshold: 0.1, // When 10% of the element is visible, trigger the callback
      };
  
      const observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          fetchMore();
        }
      }, options);

      const bottomElement = bottomElementRef.current;
  
      if (bottomElement) {
        observer.observe(bottomElement);
      }
  
      return () => {
        if (bottomElement) {
          observer.unobserve(bottomElement);
        }
      };
  }, [bottomElementRef, page, totalPages, fetching]);
  const navigate = useNavigate()
  const viewDetail = (e, transfer) => {
    e.preventDefault();
    e.stopPropagation();
    navigate(`${HomePageURL}/stock-transfers/${transfer?.id}/`)
  }
  return (
    <>
        <PageHeader title="Product Transfers" />
        <div className="row layout-top-spacing" id="cancel-row">
            <div className="col-xl-12 col-lg-12 col-sm-12  layout-spacing">
                <Link to={`${HomePageURL}/stock-transfers/create/`} className="btn btn-primary">Create a Transfer</Link>
            </div>
            <div className="col-xl-12 col-lg-12 col-sm-12  layout-spacing">
                
                <div className="widget-content widget-content-area br-6">
                    <div className="table-responsive mb-4 mt-4">
                        <table id="zero-config" className="table table-hover" style={{width: "100%"}}>
                            <thead>
                                <tr>
                                    <th className="no-content"></th>
                                    <th>Date</th>
                                    <th>Source</th>
                                    <th>Destination</th>
                                    <th>Type</th>
                                    <th>Status</th>
                                    <th className="no-content"></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    productTransfers?.map((transfer) => {
                                        const created_at = new Date(transfer?.created_at);
                                        return (
                                            <tr key={transfer?.id}>
                                                <td></td>
                                                <td>{`${created_at.getDate()}-${created_at.getMonth() + 1}-${created_at.getFullYear()} ${created_at.getHours()}:${created_at.getMinutes()}`}</td>
                                                <td>{transfer?.source?.location_type === 'Warehouse Location' ? `Warehouse: ${transfer?.source?.warehouse?.name}` : transfer?.source?.location_type}</td>
                                                <td>{transfer?.destination?.location_type === 'Warehouse Location' ? `Warehouse: ${transfer?.destination?.warehouse?.name}` : transfer?.destination?.location_type}</td>
                                                <td>{transfer?.transfer_type}</td>
                                                <td>{transfer?.status}</td>
                                                <td className="cursor-pointer">
                                                    <Link to={`${HomePageURL}/stock-transfers/${transfer?.id}/`} onClick={(e) => viewDetail(e, transfer)}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-arrow-right"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>
                                                    </Link>
                                                </td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                            <tfoot ref={bottomElementRef}></tfoot>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </>
  )
}

export default connect(null, {update_page_meta, selectProduct}) (MoveList);